module.exports = __webpack_public_path__ + "static/media/icon.d114141c.svg";